import Vue from 'vue';
import Vuex from 'vuex';

// Vuex modules
import appointments from './modules/appointments';
import appointmentFeedback from './modules/appointment-feedback';
import contactAppointments from './modules/contact-appointments';
import contactArrears from './modules/contact-arrears';
import contactPassword from './modules/contact-password';
import forwardingAddress from './modules/forwarding-address';
import inventoryFeedback from './modules/inventory-feedback';
import lead from './modules/lead';
import leadProperty from './modules/lead-property';
import leadQuestions from './modules/lead-questions';
import leaseholdEstateAppointments from './modules/leasehold-estate-appointments';
import leaseholdEstateNotifications from './modules/leasehold-estate-notifications';
import leaseholdEstateTransactions from './modules/leasehold-estate-transactions';
import leaseholdGroundRentTransactions from './modules/leasehold-ground-rent-transactions';
import leaseholdProperties from './modules/leasehold-properties';
import leaseholdProperty from './modules/leasehold-property';
import leaseholdRepairs from './modules/leasehold-repairs';
import leaseholdServiceChargeTransactions from './modules/leasehold-service-charge-transactions';
import leaseholdWorksOrders from './modules/leasehold-works-orders';
import notes from './modules/notes';
import ownerGroup from './modules/owner-group';
import pay from './modules/pay';
import portfolioProperties from './modules/portfolio-properties';
import portfolioProperty from './modules/portfolio-property';
import salesProperties from './modules/sales-properties';
import salesProperty from './modules/sales-property';
import salesPropertyOffers from './modules/sales-property-offers';
import salesPropertyViewings from './modules/sales-property-viewings';
import salesPropertyStatistics from './modules/sales-property-statistics';
import staff from './modules/staff';
import tenanciesProperties from './modules/tenancies-properties';
import tenancyArrears from './modules/tenancy-arrears';
import tenancyCharges from './modules/tenancy-charges';
import tenancyProperty from './modules/tenancy-property';
import transactions from './modules/transactions';
import twoFactorAuthentication from './modules/two-factor-authentication';
import user from './modules/user';
import users from './modules/users';
import viewingAvailability from './modules/viewing-availability';
import workflows from './modules/workflows';
import worksOrders from './modules/works-orders';
import invoices from "./modules/invoices";

Vue.use(Vuex);

export default new Vuex.Store({
    strict: true,
    modules: {
        appointments,
        appointmentFeedback,
        contactAppointments,
        contactArrears,
        contactPassword,
        forwardingAddress,
        inventoryFeedback,
        invoices,
        lead,
        leadProperty,
        leadQuestions,
        leaseholdEstateAppointments,
        leaseholdEstateNotifications,
        leaseholdEstateTransactions,
        leaseholdGroundRentTransactions,
        leaseholdProperties,
        leaseholdProperty,
        leaseholdRepairs,
        leaseholdServiceChargeTransactions,
        leaseholdWorksOrders,
        notes,
        ownerGroup,
        pay,
        portfolioProperties,
        portfolioProperty,
        salesProperties,
        salesProperty,
        salesPropertyOffers,
        salesPropertyStatistics,
        salesPropertyViewings,
        staff,
        tenanciesProperties,
        tenancyArrears,
        tenancyCharges,
        tenancyProperty,
        transactions,
        twoFactorAuthentication,
        user,
        users,
        viewingAvailability,
        workflows,
        worksOrders,
    },
});
